import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Growl } from "primereact/growl";
import constant from './../constant/Constant';
import { AppBreadcrumb } from "../AppBreadcrumb";
import { HttpService } from "../service/HttpService";
import { withRouter } from "react-router-dom";

import "./SearchQrCodeAdvanceSearch.css";

class SearchQrCodeAdvanceSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            qrCode: "",
            isSearching: false,

            searchJobs: [],
            loadingJobs: false,

            first: 0,
            rows: 10,
            totalRecords: 0,

            showResultDialog: false,
            selectedJob: null,
            searchResults: [],
            loadingResults: false
        };

        this.httpService = new HttpService();

        this.getSearchJobs = this.getSearchJobs.bind(this);
        this.startQrCodeSearch = this.startQrCodeSearch.bind(this);
        this.viewDetails = this.viewDetails.bind(this);
        this.closeResultDialog = this.closeResultDialog.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        this.getSearchJobs(0, 10);
    }

    // ============================================================
    // LOAD SEARCH JOB HISTORY
    // ============================================================

    getSearchJobs = (page, size) => {

        this.setState({
            loadingJobs: true
        });

        const pageNumber = Math.floor(page / size);

        const url =
            `qrCode/search-jobs?page=${pageNumber}&size=${size}&sortBy=startedAt&sortDirection=desc`;

        this.httpService
            .getApi(url)
            .then((response) => {

                if (response && response.data) {

                    this.setState({
                        searchJobs: response.data.content || [],
                        totalRecords: response.data.totalElements || 0,
                        first: page,
                        rows: size,
                        loadingJobs: false
                    });

                } else {

                    this.setState({
                        searchJobs: [],
                        totalRecords: 0,
                        loadingJobs: false
                    });
                }
            })
            .catch(() => {

                this.setState({
                    searchJobs: [],
                    totalRecords: 0,
                    loadingJobs: false
                });

                this.showError(
                    "Unable to load QR code search history."
                );
            });
    };

    // ======================= This is the function of file download by dialog box...
    downloadButtonTemplate = (rowData) => {
        return (
            // <Button
            //     icon="pi pi-download"
            //     className="p-button-sm p-button-text"
            //     tooltip="Download File"
            //     tooltipOptions={{ position: "top" }}
            //     onClick={() => this.downloadFile(rowData.fileName)}
            // />
            <Button
                label="↓"
                className="p-button-sm p-button-text"
                tooltip="Download File"
                tooltipOptions={{ position: "top" }}
                onClick={() => this.downloadFile(rowData.fileName)}
            />
        );
    };

    downloadFile = (fileName) => {
        if (!fileName) {
            return;
        }

        console.log("Downloading file:", fileName);
        // file donwload from docker start.

        var a = document.createElement('a');
        a.href = constant.TEMPLATE_URl + fileName;
        a.download = fileName;
        a.target = '_blank';
        a.click();
        a.remove();

        // file download from docker end.
    };

    // ============================================================
    // START QR CODE SEARCH
    // ============================================================

    startQrCodeSearch = () => {

        const qrCode = this.state.qrCode.trim();

        if (!qrCode) {
            this.showError("Please enter QR Code.");
            return;
        }

        if (this.state.isSearching) {
            return;
        }

        this.setState({
            isSearching: true
        });

        const customerId = "CUST00001";

        const url =
            `qrCode/start?qrCode=${encodeURIComponent(qrCode)}&customerId=${encodeURIComponent(customerId)}`;

        this.httpService
            .postApi(url)
            .then((response) => {

                if (response && response.data) {

                    const data = response.data;

                    this.showSuccess(
                        data.message || "Search started successfully."
                    );

                    this.setState({
                        isSearching: false,
                        qrCode: ""
                    });

                    this.getSearchJobs(0, this.state.rows);

                } else {

                    this.setState({
                        isSearching: false
                    });

                    this.showError(
                        "Unable to start QR code search."
                    );
                }
            })
            .catch(() => {

                this.setState({
                    isSearching: false
                });

                this.showError(
                    "Unable to start QR code search."
                );
            });
    };

    // ============================================================
    // VIEW DETAILS
    // ============================================================

    viewDetails = (rowData) => {

        if (!rowData || !rowData.id) {

            this.showError("Search Job ID not found.");
            return;
        }

        this.setState({
            showResultDialog: true,
            selectedJob: rowData,
            searchResults: [],
            loadingResults: true
        });

        const url =
            `qrCode/results/${rowData.id}`;

        this.httpService
            .getApi(url)
            .then((response) => {

                if (response && response.data) {

                    this.setState({
                        searchResults: response.data || [],
                        loadingResults: false
                    });

                } else {

                    this.setState({
                        searchResults: [],
                        loadingResults: false
                    });
                }
            })
            .catch(() => {

                this.setState({
                    searchResults: [],
                    loadingResults: false
                });

                this.showError(
                    "Unable to load search result details."
                );
            });
    };

    // ============================================================
    // CLOSE RESULT DIALOG
    // ============================================================

    closeResultDialog = () => {

        this.setState({
            showResultDialog: false,
            selectedJob: null,
            searchResults: []
        });
    };

    // ============================================================
    // PAGINATION
    // ============================================================

    onPageChange = (event) => {

        this.getSearchJobs(
            event.first,
            event.rows
        );
    };

    // ============================================================
    // STATUS
    // ============================================================

    statusBodyTemplate = (rowData) => {

        let statusClass = "search-qr-status-default";

        if (rowData.status === "COMPLETED") {
            statusClass = "search-qr-status-success";
        } else if (rowData.status === "FAILED") {
            statusClass = "search-qr-status-danger";
        } else if (
            rowData.status === "IN_PROGRESS" ||
            rowData.status === "PENDING"
        ) {
            statusClass = "search-qr-status-warning";
        }

        return (
            <span className={`search-qr-status ${statusClass}`}>
                {rowData.status || "-"}
            </span>
        );
    };

    // ============================================================
    // VIEW BUTTON
    // ============================================================

    actionBodyTemplate = (rowData) => {

        return (
            <Button
                type="button"
                label="View Detail"
                icon="pi pi-eye"
                className="search-qr-view-button p-button-sm"
                onClick={() => this.viewDetails(rowData)}
            />
        );
    };

    // ============================================================
    // DATE FORMAT
    // ============================================================

    dateBodyTemplate = (rowData, field) => {

        if (!rowData[field]) {
            return "-";
        }

        const date = new Date(rowData[field]);

        if (isNaN(date.getTime())) {
            return "-";
        }

        return date.toLocaleString();
    };

    // ============================================================
    // GROWL
    // ============================================================

    showSuccess = (message) => {

        if (this.growl) {

            this.growl.show({
                severity: "success",
                summary: "Success",
                detail: message
            });
        }
    };

    showError = (message) => {

        if (this.growl) {

            this.growl.show({
                severity: "error",
                summary: "Error",
                detail: message
            });
        }
    };

    // ============================================================
    // RESULT DIALOG
    // ============================================================

    renderResultDialog = () => {

        const selectedJob = this.state.selectedJob;

        return (
            <Dialog
                visible={this.state.showResultDialog}
                onHide={this.closeResultDialog}
                modal={true}
                maximizable
                className="search-qr-result-dialog"
                header={
                    <div className="search-qr-dialog-header">

                        <div className="search-qr-dialog-header-icon">
                            <i className="pi pi-search" />
                        </div>

                        <div className="search-qr-dialog-header-content">

                            <div className="search-qr-dialog-heading">
                                QR Search Details
                            </div>

                            {selectedJob && (
                                <div className="search-qr-dialog-subheading">
                                    Search Job&nbsp;
                                    <span>{selectedJob.id}</span>
                                </div>
                            )}

                        </div>

                    </div>
                }
            >

                {selectedJob && (

                    <div className="search-qr-dialog-content">

                        {/* ========================================================
                        SUMMARY SECTION
                    ======================================================== */}

                        <div className="search-qr-dialog-summary">

                            {/* QR CODE */}

                            <div className="search-qr-dialog-summary-card">

                                <div className="search-qr-dialog-summary-icon">
                                    <i className="pi pi-th-large" />
                                </div>

                                <div className="search-qr-dialog-summary-content">

                                    <div className="search-qr-dialog-summary-label">
                                        QR Code
                                    </div>

                                    <div
                                        className="search-qr-dialog-summary-value search-qr-dialog-qr-value"
                                        title={selectedJob.qrCode || "-"}
                                    >
                                        {selectedJob.qrCode || "-"}
                                    </div>

                                </div>

                            </div>

                            {/* STATUS */}

                            <div className="search-qr-dialog-summary-card">

                                <div className="search-qr-dialog-summary-icon">
                                    <i className="pi pi-info-circle" />
                                </div>

                                <div className="search-qr-dialog-summary-content">

                                    <div className="search-qr-dialog-summary-label">
                                        Status
                                    </div>

                                    <div className="search-qr-dialog-summary-value">
                                        {this.statusBodyTemplate(selectedJob)}
                                    </div>

                                </div>

                            </div>

                            {/* MATCHING FILES */}

                            <div className="search-qr-dialog-summary-card">

                                <div className="search-qr-dialog-summary-icon">

                                    <i className="pi pi-file" />

                                </div>

                                <div className="search-qr-dialog-summary-content">

                                    <div className="search-qr-dialog-summary-label">
                                        Matching Files
                                    </div>

                                    <div className="search-qr-dialog-summary-value search-qr-dialog-count-value">
                                        {selectedJob.matchingFiles || 0}
                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* ========================================================
                        RESULTS HEADER
                    ======================================================== */}

                        <div className="search-qr-dialog-results-section">

                            <div className="search-qr-dialog-results-header">

                                <div className="search-qr-dialog-results-title-area">

                                    <div className="search-qr-dialog-results-icon">

                                        <i className="pi pi-search" />

                                    </div>

                                    <div>

                                        <div className="search-qr-dialog-results-title">
                                            Matching Files
                                        </div>

                                        <div className="search-qr-dialog-results-subtitle">
                                            Files where the requested QR code was found
                                        </div>

                                    </div>

                                </div>

                                <div className="search-qr-dialog-results-badge">
                                    {this.state.searchResults.length} Result
                                    {this.state.searchResults.length !== 1
                                        ? "s"
                                        : ""}
                                </div>

                            </div>


                            {/* ====================================================
                            RESULT TABLE
                        ==================================================== */}

                            <div className="search-qr-dialog-table-container">

                                <DataTable
                                    value={this.state.searchResults}
                                    loading={this.state.loadingResults}
                                    emptyMessage="No matching files found."
                                    responsive
                                    scrollable
                                    scrollHeight="42vh"
                                    className="search-qr-dialog-result-table p-datatable-sm"
                                >

                                    <Column
                                        field="id"
                                        header="Result ID"
                                        style={{
                                            width: "125px",
                                            minWidth: "125px"
                                        }}
                                    />

                                    <Column
                                        field="fileName"
                                        header="File Name"
                                        body={(rowData) => (
                                            <div
                                                className="search-qr-dialog-file-name"
                                                title={rowData.fileName || "-"}
                                            >
                                                {rowData.fileName || "-"}
                                            </div>
                                        )}
                                        style={{
                                            minWidth: "300px"
                                        }}
                                    />

                                    <Column
                                        field="lineNumber"
                                        header="Line Number"
                                        style={{
                                            width: "120px",
                                            minWidth: "120px"
                                        }}
                                    />

                                    <Column
                                        field="matchedData"
                                        header="Matched Data"
                                        body={(rowData) => (
                                            <div
                                                className="search-qr-dialog-matched-data"
                                                title={rowData.matchedData || "-"}
                                            >
                                                {rowData.matchedData || "-"}
                                            </div>
                                        )}
                                        style={{
                                            minWidth: "330px"
                                        }}
                                    />

                                    {/* details for file download links */}
                                    <Column
                                        header="Download"
                                        body={this.downloadButtonTemplate}
                                        style={{
                                            width: "120px",
                                            minWidth: "120px",
                                            textAlign: "center"
                                        }}
                                    />

                                    {/* details for file download links */}

                                </DataTable>

                            </div>

                        </div>

                    </div>
                )}

            </Dialog>
        );
    };

    // ============================================================
    // MAIN RENDER
    // ============================================================

    render() {

        return (
            <div className="search-qr-advance-page">

                <Growl
                    ref={(el) => (this.growl = el)}
                />


                <AppBreadcrumb
                    home={{
                        icon: "pi pi-home",
                        to: "/dashboard"
                    }}
                    items={[
                        {
                            label: "Search QR Code File"
                        }
                    ]}
                />


                {/* =====================================================
                    MAIN CARD
                ====================================================== */}

                <div className="search-qr-main-card">

                    {/* =================================================
                        SEARCH SECTION
                    ================================================== */}

                    <div className="search-qr-search-section">

                        <div className="search-qr-section-title">

                            <div className="search-qr-section-icon">
                                <i className="pi pi-search" />
                            </div>

                            <div>

                                <div className="search-qr-section-heading">
                                    Search QR Code
                                </div>

                                <div className="search-qr-section-description">
                                    Enter a QR code to search across available files.
                                </div>

                            </div>

                        </div>


                        <div className="search-qr-search-controls">

                            <div className="search-qr-input-wrapper">

                                <span className="p-float-label">

                                    <InputText
                                        id="qrCode"
                                        value={this.state.qrCode}
                                        onChange={(e) =>
                                            this.setState({
                                                qrCode: e.target.value
                                            })
                                        }
                                        onKeyDown={(e) => {

                                            if (e.key === "Enter") {
                                                this.startQrCodeSearch();
                                            }

                                        }}
                                        className="search-qr-input"
                                        autoComplete="off"
                                    />

                                    <label htmlFor="qrCode">
                                        Enter QR Code
                                    </label>

                                </span>

                            </div>


                            <div className="search-qr-button-wrapper">

                                <Button
                                    label={
                                        this.state.isSearching
                                            ? "Searching..."
                                            : "Search"
                                    }
                                    icon={
                                        this.state.isSearching
                                            ? "pi pi-spin pi-spinner"
                                            : "pi pi-search"
                                    }
                                    disabled={this.state.isSearching}
                                    onClick={this.startQrCodeSearch}
                                    className="search-qr-search-button"
                                />

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        SEARCH HISTORY
                    ================================================== */}

                    <div className="search-qr-history-section">

                        <div className="search-qr-history-header">

                            <div className="search-qr-history-title-area">

                                <div className="search-qr-history-icon">
                                    <i className="pi pi-search" />
                                </div>

                                <div>

                                    <div className="search-qr-history-title">
                                        QR Code Search History
                                    </div>

                                    <div className="search-qr-history-subtitle">
                                        View previous QR code search requests and their results.
                                    </div>

                                </div>

                            </div>

                            <div className="search-qr-history-total">
                                {this.state.totalRecords} Search
                                {this.state.totalRecords !== 1 ? "es" : ""}
                            </div>

                        </div>


                        <div className="search-qr-history-table-wrapper">

                            <DataTable
                                value={this.state.searchJobs}
                                lazy
                                paginator
                                first={this.state.first}
                                rows={this.state.rows}
                                totalRecords={this.state.totalRecords}
                                onPage={this.onPageChange}
                                loading={this.state.loadingJobs}
                                responsive
                                className="search-qr-history-table p-datatable-sm"
                                emptyMessage="No QR code search history found."
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rowsPerPageOptions={[10, 20, 50]}
                            >

                                <Column
                                    field="qrCode"
                                    header="QR Code"
                                    style={{
                                        minWidth: "150px"
                                    }}
                                />

                                <Column
                                    field="status"
                                    header="Status"
                                    body={this.statusBodyTemplate}
                                    style={{
                                        minWidth: "125px"
                                    }}
                                />

                                <Column
                                    field="totalFiles"
                                    header="Total Files"
                                    style={{
                                        minWidth: "110px"
                                    }}
                                />

                                <Column
                                    field="filesScanned"
                                    header="Files Scanned"
                                    style={{
                                        minWidth: "125px"
                                    }}
                                />

                                <Column
                                    field="matchingFiles"
                                    header="Matching Files"
                                    style={{
                                        minWidth: "135px"
                                    }}
                                />

                                <Column
                                    field="completedAt"
                                    header="Completed At"
                                    body={(rowData) =>
                                        this.dateBodyTemplate(
                                            rowData,
                                            "completedAt"
                                        )
                                    }
                                    style={{
                                        minWidth: "180px"
                                    }}
                                />

                                <Column
                                    header="Action"
                                    body={this.actionBodyTemplate}
                                    style={{
                                        width: "145px",
                                        minWidth: "145px"
                                    }}
                                />

                            </DataTable>

                        </div>

                    </div>

                </div>


                {this.renderResultDialog()}

            </div>
        );
    }
}

export default withRouter(SearchQrCodeAdvanceSearch);